
import {
    defineComponent,
    ref
} from 'vue'
import sHeader from "@/components/shared/subHeader.vue"

export default defineComponent({
    components: {
        sHeader
    },
    setup() {
        const textSearch = ref('')
        return {
            textSearch
        }

    },
})
